import React, { Fragment, useEffect, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { ReactComponent as CancelIcon } from '../../Assets/Icons/cancel.svg';
// import { useLandingPage } from '../../Services/hooks/landingpage';
// import { ReactComponent as NameIcon } from '../../Assets/Icons/nameIcon.svg';
// import { ReactComponent as EmailIcon } from '../../Assets/Icons/emailicon.svg';
// import { ReactComponent as PhoneInputIcon } from '../../Assets/Icons/phoneinputicon.svg';
import { ReactComponent as Telegram } from '../../Assets/Icons/telegramicon.svg';
import { useSingleProperty } from '../../Services/hooks/SingleProperty';
import { useSelector } from 'react-redux';
import { RootState } from '../../Storeredux/reducers/rootReducer';
import { userData } from '../../Storeredux/constants/actionTypes';

interface Props {
  isOpen: boolean;
  onHide: () => void;
  propertyId: string;
}

function BookInspection({ isOpen, onHide, propertyId }: Props) {
  const UserState = useSelector((state: RootState) => state.user as userData);
  const { user } = UserState;
  const [data, setData] = useState({
    name: '',
    available_date : '',
    available_time : '',
    email : '',
    phone_number : '',
    message : '',
  });
  // const { loading } = useLandingPage();
  const { BookPropertyInspection, loading } = useSingleProperty();
  const [errorState, setErrorState] = useState({
    phone: '',
    bvn: '',
  });
  const validatePhoneNumber = (phoneNumber: string) => {
    console.log('validate', phoneNumber);
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    const expectedLength = 11;
    if (digitsOnly.length === expectedLength) {
      setData({ ...data, phone_number: phoneNumber });
      setErrorState({ ...errorState, phone: '' });
    } else {
      // setData({ ...data, phone: '' });
      setErrorState({ ...errorState, phone: 'Invalid Phone Number' });
    }
  };
  const onChange = (e: any) => {
    setData({ ...data, [e.target.name]: e.target.value });
    if (e.target.name === 'phone_number') {
      console.log(e.target.value);
      validatePhoneNumber(e.target.value);
      return;
    }
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const areAllKeysFilled = (obj: any) => {
    for (const key in obj) {
      // eslint-disable-next-line no-prototype-builtins
      const value = obj.hasOwnProperty(key);
      if (value) {
        if (!obj[key]) {
          return false;
        }
      }
    }
    return true;
  };
  const isFormComplete = areAllKeysFilled(data);
  const onSubmit = async (e: any) => {
    e.preventDefault();
    if (errorState.phone) {
      setErrorState({ ...errorState, bvn: 'Please enter a valid phone number' });
    } else if (isFormComplete) {
      const payload = {
        user_id: user.id,
        name: data.name,
        available_date : data.available_date,
        available_time : data.available_time,
        property_id : propertyId,
        email : data.email,
        phone_number : data.phone_number,
      };
      await BookPropertyInspection(payload);
      // setData({ ...data, name: '',
      //   email: '',
      //   phone: '',
      //   property_type: 'home',
      //   message: '' },
      // );
      onHide();
    } else {
      setErrorState({ ...errorState, bvn: 'Please complete the form information' });
    }

  };
  console.log(user);
  useEffect(() => {
    if (user) {
      setData({
        name: user.name || '',
        email: user.email || '',
        phone_number: user.phone || '',
        available_date: '',
        available_time: '',
        message: '',
      });
    }
  }, []);
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onHide}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className="w-full transform overflow-hidden lg:max-w-[55%] xl:max-w-[40%] rounded-2xl bg-white text-left align-middle shadow-xl transition-all">
                <div className='flex justify-end px-4 py-4'>
                  <CancelIcon onClick={onHide} className='cursor-pointer'/>
                </div>
                <div className='justify-center p-7 lg:p-14 lg:pt-7 pt-3.5'>
                  <h1 className={'font-bold text-2xl pb-1.5'}>Book Inspection Date</h1>
                  <p className={'text-xs text-gray-600 pb-3'}>So our agent can reach out to you on time</p>
                  <form className={'w-full flex flex-col gap-y-3'} onSubmit={onSubmit}>
                    <div className={'flex gap-2'}>
                      <div className="w-1/2">
                        <label className=" text-sm pb-2">
                          Full name
                        </label>
                        <div className="relative pt-1.5">
                          <input name={'name'} value={data.name} onChange={onChange}
                                 className="focus-visible:outline-0 w-full p-4 py-2.5 border rounded bg-custom-extra-light-green border-custom-darkgreen"
                                 type="text" placeholder="Enter your name" />
                        </div>
                      </div>
                      <div className="w-1/2">
                        <label className=" text-sm pb-2">
                          Available Date
                        </label>
                        <div className="relative pt-1.5">
                          <input name={'available_date'} value={data.available_date} onChange={onChange}
                                 className="focus-visible:outline-0 w-full p-4 py-2.5 border rounded bg-custom-extra-light-green border-custom-darkgreen"
                                 type="date" placeholder="DD/MM/YYYY" />
                        </div>
                      </div>
                    </div>
                    <div className={'flex gap-2'}>
                      <div className="w-1/2">
                        <label className=" text-sm pb-2">
                          Email
                        </label>
                        <div className="relative pt-1.5">
                          <input name={'email'} value={data.email} onChange={onChange}
                                 className="focus-visible:outline-0 w-full p-4 py-2.5 border rounded bg-custom-extra-light-green border-custom-darkgreen"
                                 type="email" placeholder="Enter your email" />
                        </div>
                      </div>
                      <div className="w-1/2">
                        <label className=" text-sm pb-2">
                          Available time
                        </label>
                        <div className="relative pt-1.5">
                          <input name={'available_time'} value={data.available_time} onChange={onChange}
                                 className="focus-visible:outline-0 w-full p-4 py-2.5 border rounded bg-custom-extra-light-green border-custom-darkgreen"
                                 type="time" placeholder="HH:MM" />
                        </div>
                      </div>
                    </div>
                    <div className={'flex gap-2'}>
                      <div className="w-1/2">
                        <label className=" text-sm pb-2">
                          Phone Number
                        </label>
                        <div className="relative pt-1.5">
                          <input name={'phone_number'} value={data.phone_number} onChange={onChange}
                                 className="focus-visible:outline-0 w-full p-4 py-2.5 border rounded bg-custom-extra-light-green border-custom-darkgreen"
                                 type="text" placeholder="Enter your phone number" />
                        </div>
                        {errorState.phone && (
                          <div className="text-red-500 text-xs my-1">
                            {errorState.phone}
                          </div>
                        )}
                      </div>
                      <div className="w-1/2">
                        <label className="text-sm pb-2">
                          Share your message
                        </label>
                        <div className="relative pt-1.5">
                          <textarea name={'message'} value={data.message} onChange={onChange}
                                 className="focus-visible:outline-0 w-full p-4 py-2.5 border rounded bg-custom-extra-light-green border-custom-darkgreen"
                                 placeholder="message" />
                        </div>
                      </div>
                    </div>

                    {errorState.bvn && (
                      <div className="text-red-500 text-xs my-1">
                        {errorState.bvn}
                      </div>
                    )}
                    <button
                      className={`${isFormComplete ? 'bg-green-600' : 'bg-green-600'} flex justify-between self-center items-center h-fit rounded-custom border-0 text-white py-3.5 px-5`}>
                      <div className='flex justify-center px-1.5'>
                        <Telegram className='' />
                      </div>
                      {loading ? <div className="lds-spinner">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div> : <div
                        className={'border-l border-gray-400 font-bold px-3 flex flex-row'}>Book Now</div>
                      }
                      {/*<div className='border-l border-gray-400 font-bold px-3 flex flex-row'>Send Request</div>*/}
                    </button>
                  </form>
                </div>

              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default BookInspection;
